import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledControlsWrapper = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  ${setFontVariant('caption', colorsPalettes.carbon[300])};
`;

export const StyledControlIcon = styled(SWReactIcons)<{ disabled?: boolean }>`
  width: 24px;
  height: 24px;

  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  svg {
    width: 24px;
    height: 24px;

    path {
      transition: fill 0.2s ease-in;
    }
  }
`;

export const StyledControlLink = styled.a`
  height: 100%;
`;

export const StyledCurrentPage = styled.span`
  padding-left: 6px;
  padding-right: 2px;
`;

export const StyledTotalPages = styled.span`
  padding-right: 6px;
  padding-left: 2px;
`;
